<template>
<!-- 资料评审页面(目前只有政策有此页面) -->
<div class="policyApplyView">
            <el-form   label-width="140px" :model="ruleForm" :rules="rules" ref="ruleForm" class="ruleForm">
                <!-- 名称 不需要搜索-直接上一页传过来 prop="policyName" 仅展示-不可编辑 -->
                <el-form-item label="政策名称" class="fileProp">
                    <p class="policyNameCss">{{ruleForm.policyName}}</p>
                </el-form-item>
                <!-- 需求描述 -->
                <el-form-item label="描述" prop="content" class="fileProp">
                    <el-input placeholder="请输入详细描述" v-model="ruleForm.content" :rows="6" :maxlength="300" :show-word-limit="true" type="textarea"> </el-input>
                </el-form-item>

                <!-- 上传文件 必传 prop="isFile"-->
                 <el-form-item label="上传文件" prop='fileList' class="fileProp">
                    <el-upload
                        class="upload-demo"
                        :action='imgActions'
                        name="file"
                        :on-preview="handlePreview"
                        :on-remove="handleRemove"
                        :before-remove="beforeRemove"
                        :on-success='handleAvatarSuccess'
                        :on-error='handleAvatarError'
                        multiple
                        :limit="10"
                        :on-exceed="handleExceed"
                        :file-list="ruleForm.fileList"
                        >
                        <el-button size="small" type="primary">点击上传</el-button>
                        <div slot="tip" class="el-upload__tip">支持.doc .docx .pdf .jpg .png，大小不超过50M</div>
                    </el-upload>
                </el-form-item>
                <el-form-item label="">
                    <el-button @click="submitForm('ruleForm')" type="primary" >立即申请</el-button>
                    <el-button @click="cancle" >&nbsp;&nbsp;取消&nbsp;&nbsp;</el-button>
                </el-form-item>

            </el-form>
        </div>     
</template>

<script>

    export default {
        name: "lp-policy-review",
         data() {
                //  手机验证
                const  valiPhone = (rule, value, callback) => {
                    if (!/^[0-9][0-9]\d{9}$/.test(value)) {
                        callback(new Error('请输入正确的手机号'));
                    } else {
                        callback();
                    }
                };
                // 上传文件验证
                const  fileChecked = (rule, value, callback) => {
                     if(value!==null){
                        if(value.length>0){
                             callback();
                        }else{
                             callback(new Error('请先上传文件'));

                        }
                    }else{
                        callback(new Error('请先上传文件'));
                    }
                };
                const { query:{type,title},params:{code:id} }=this.$route;

                return {
                    serverOrderType:3,//服务订单类型:1申请  2咨询  3预审
                    detailType:parseInt(type),//type=1政策，type=4服务
                    imgActions:`${process.env.baseURL}/file/upload`,
                    ruleForm:{
                        policyName:title,//名称
                        content:'',//描述
                        fileList:[]//文件
                    },
                    rules: {  
                        content: [
                            { required: true, message: '请输入描述', trigger: 'blur' }
                        ], 
                        fileList:[
                            { validator: fileChecked, trigger: 'blur' }
                        ]  
                    },

                };
        },
        // created(){//此页面仅作为评审页面
        //     const { query:{orderType} } =this.$route;
        //     this.serverOrderType=orderType;
        // },
        mounted() {
             //初始化ruleForm数据
            this.ruleForm=this.initForm();
        },
        methods: {
              // 取消-返回上一页
            cancle() {
                window.history.go(-1);
            },
            /*文件上传开始*/
            // 上传失败
            handleAvatarError(){
                 this.$message.warning(`上传失败`);
            },
            // 上传成功 
            handleAvatarSuccess(res, file) {
                 const {data,code:datacode,msg}=res
                if(datacode==1){
                   
                    let imgdata={
                        name:data.originName,
                        url:data.url,
                        fileSize:data.fileSize
                    }
                    this.ruleForm.fileList.push(imgdata)
                 }else{
                    this.$message.warning(msg);
                }

            },
            // 移除文件
            handleRemove(file, fileList) {
                 this.ruleForm.fileList=fileList

            },
            // 点击文件列表中已上传的文件
            handlePreview(file) {
                 if(file.url!==null){
                    window.open(file.url)
                }
            },
            // 文件超出个数限制
            handleExceed(files, fileList) {
                this.$message.warning(`当前限制选择 10 个文件`);
                // this.$message.warning(`当前限制选择 10 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
            },
            // 移除文件-提示
            beforeRemove(file, fileList) {
                return this.$confirm(`确定移除 ${ file.name }？`);
            },  

            /*文件上传结束*/
            // 移除该表单项的校验结果  this.$refs['ruleForm'].clearValidate();
            //初始化数据
            initForm(){
                const { query:{type,title},params:{code:id} }=this.$route;
                return {
                    policyName:title,//名称
                    content:'',//描述
                    fileList:[]//图片 
                }
            },
          
            /*
            立即提交
            */
            submitForm(formName) {
                const { query:{type,title},params:{code:id} }=this.$route;
                //提交接口
                const {ruleForm,mechanismId,typeList,serverOrderType}=this;
                this.$refs[formName].validate(async (valid) => {
                    if (valid) {
                        /*评审*/
                       var imagesArr=ruleForm.fileList.map((item)=>{ return item.url});
                        var params={
                            image:imagesArr.join(','),//文件地址
                            companyId:localStorage.getItem('companyId')?localStorage.getItem('companyId'):'',
                            policyId:id,//详情id,仅有政策有评审资料功能！
                            remark:ruleForm.content,//描述
                            serverOrderType,//服务订单类型:1申请  2咨询  3预审
                            // type=1政策，type=4服务，
                            serverOrderSource:type==1?1:type==4?2:'',// 服务订单来源:1政策!  2第三方服务!  3服务(机构)  4其它
                            name:title//标题
                        }
                        const res= await this.$Apis.getPolicyTermsList(params);
                        const { code,data,msg }=res;
                        if(code==1){
                            this.$message.success('提交成功，请到企业管理中心查看申请进度');
                            this.$router.go(-1);
                        }
                    }
                })
            },
        }
    }
</script>


<style lang="less" scoped>
.policyApplyView{
        background-color: #fff;
        width: 100%;
        padding: 50px 38px 28px 38px;
        box-sizing: border-box;
        // flex: 1;
        flex-grow: 1;
        .ruleForm{
            // /deep/ .el-form-item__label:before {
            //     display: none;
            // }
            .el-input,
            .el-select,
            .el-date-editor{
                width: 200px;
                height: 36px;
                line-height: 36px;
                /deep/ .el-input__inner{
                    height: 36px;
                    line-height: 36px;
                }
                /deep/ .el-input-group__append {
                    height: 34px;
                    line-height: 34px;
                    box-sizing: border-box;
                }
            }
            .el-textarea,.upload-demo{
                width: 500px;
            } 
        }
        // 指定模块添加星号
        .el-form{
            // 星号都不要，选填加括号
            /deep/ .fileProp{
                    .el-form-item__label::before{
                        content: ''!important;
                    }
                }
            // /deep/ .fileProp{
            //         .el-form-item__label::before{
            //             content: '*';
            //             color: #F56C6C;
            //             margin-right: 4px;
            //         }
            //     }
        }
        .policyNameCss{
            // height: 40px;
            // line-height: 40px;
            font-family: MicrosoftYaHei;
            font-size: 14px;
            // color: #333333;
        }
            
           .el-form-item__label:before {
                content: '*';
                color: #F56C6C;
                margin-right: 4px;
            }
             // 图片上传
            .imgList{
                display: flex;
                flex-wrap: wrap;
                img{
                    width: 148px;
                    height: 148px;
                    margin-right: 20px;
                    border: 1px dashed #d9d9d9;
                    box-sizing: border-box;
                }
            }
            .policyTerms{
                color: @hoverDefaultColor;
            }
    }

</style>


// WEBPACK FOOTER //
// src/components/policyreview/index.vue